<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <div v-if="loading">Carregando membros...</div>
        <material-card
          color="success"
          title="Membros"
          text="Membros cadastrados na plataforma"
          v-if="!loading"
        >
          <v-form ref="form" v-model="valid" lazy-validation v-if="!loading">
            <v-container>
              <v-layout>
                <v-flex xs3 md3 class="text-lg-left px-1">
                  <v-text-field
                    v-model="name"
                    label="Nome"
                    class="purple-input"
                    @keyup.enter="_search"
                  />
                </v-flex>
                <v-flex xs3 md3 class="text-lg-left px-1">
                  <v-text-field
                    v-model="email"
                    label="Email"
                    class="purple-input"
                    @keyup.enter="_search"
                  />
                </v-flex>
                <v-flex xs2 md2 class="text-lg-left px-1">
                  <v-text-field
                    v-model="phone"
                    label="Telefone"
                    class="purple-input"
                    @keyup.enter="_search"
                  />
                </v-flex>
                <v-flex xs2 md2 class="text-lg-left px-1">
                  <v-text-field
                    v-model="cpf"
                    label="CPF"
                    class="purple-input"
                    @keyup.enter="_search"
                  />
                </v-flex>
                <v-flex xs4 md3 class="text-lg-left px-1">
                  <v-autocomplete
                    :items="status_list"
                    item-text="label"
                    item-value="status"
                    label="Status"
                    v-model="status"
                    @keyup.enter="_search"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4 md3 class="text-lg-left px-1">
                  <v-autocomplete
                    :items="companies"
                    item-text="text"
                    item-value="value"
                    label="Empresa"
                    v-model="company"
                    @keyup.enter="_search"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs2 md2 class="px-1">
                  <v-btn
                    color="success"
                    outline
                    small
                    block
                    slot="start"
                    @click="_search"
                    :disabled="!valid || loading_search"
                    :loading="loading_search"
                  >
                    <v-icon left>search</v-icon>Buscar
                  </v-btn>
                </v-flex>
                <v-flex xs2 md2 class="px-1">
                  <v-btn
                    color="tertiary"
                    small
                    outline
                    block
                    slot="start"
                    @click="_clear"
                    :disabled="!valid || loading_search"
                  >
                    <v-icon left>clear</v-icon>Limpar
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex md8 />
                <v-flex xs12 md2 class="px-1">
                  <v-btn
                    class="mx-0 font-weight-light"
                    small
                    block
                    color="primary"
                    @click.prevent="newCustomer()"
                  >
                    <v-icon left dark>add</v-icon>Novo Cliente
                  </v-btn>
                </v-flex>
                <v-flex xs12 md2 class="px-1">
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="primary"
                    outline
                    small
                    block
                    :disabled="loading"
                    @click.prevent="openMyDialog"
                    ><v-icon left dark>get_app</v-icon>Exportar</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <template v-slot:loading>
            <v-progress-linear
              v-if="loading"
              height="2"
              color="cyan"
              indeterminate
            ></v-progress-linear>
          </template>
          <v-data-table
            dense
            light
            :headers="headers"
            :items="items"
            :total-items="totalItems"
            :pagination.sync="pagination"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            sort-icon="mdi-menu-down"
            item-key="id"
            :loading="loading"
            :rows-per-page-items="rowsPerPageItems"
            rows-per-page-text="Linhas por página"
            no-data-text="Não há membros cadastrados"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.created_at | formatarData }}</td>
              <td>{{ item.updated_at | formatarData }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.signedcontract_by || "" }}</td>
              <td>{{ item.status || "" | formatUserStatus }}</td>
              <td class="text-xs-right">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <a
                      :href="
                        encodeURI(
                          'https://api.whatsapp.com/send?phone=' +
                            formatWhatsappPhone(item.phone) +
                            '&text=Olá ' +
                            String(item.name ? item.name.split(' ')[0] : '') +
                            '.',
                        )
                      "
                      target="_blank"
                    >
                      <v-icon v-on="on">mdi-whatsapp</v-icon>
                    </a>
                  </template>
                  <span>Enviar WhatsApp</span>
                </v-tooltip>
              </td>
              <td>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" @click.prevent="customerSelected(item)"
                      >visibility</v-icon
                    >
                  </template>
                  <span>Editar Cliente e UC</span>
                </v-tooltip>
              </td>
              <td>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" @click.prevent="goToCustomerCare(item)"
                      >accessibility_new</v-icon
                    >
                  </template>
                  <span>Ver esse cliente na tela de atendimento</span>
                </v-tooltip>
              </td>
              <td>
                <div class="text-xs-center">
                  <v-badge left color="#7d3dff" v-if="!item.utility_cert">
                    <template v-slot:badge>
                      <span v-if="item.generated_link">{{
                        item.generated_link
                      }}</span>
                    </template>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" @click.prevent="generateLink(item)"
                          >link</v-icon
                        >
                      </template>
                      <span>Gerar link para conexão com concessionária</span>
                    </v-tooltip>
                  </v-badge>

                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" @click.prevent="decryptData(item)"
                        >preview</v-icon
                      >
                    </template>
                    <span>Descriptografar dados do usuário</span>
                  </v-tooltip>
                </div>
              </td>
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning"
                >Sua busca para "{{ search }}" não retornou resultados.</v-alert
              >
            </template>
            <template v-slot:pageText="items"
              >Linhas {{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }}</template
            >
          </v-data-table>
        </material-card>
      </v-flex>
      <cpnCreateExport />
      <!-- MODAL de Status da Unidade Consumidora -->
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-text class="headline">
            Tem certeza que deseja
            <span class="font-weight-bold">{{
              canceledOrActivatedText()
            }}</span>
            essa unidade consumidora?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="mr-2"
              color="grey darken-1"
              text
              @click="dialog = false"
              >Não</v-btn
            >
            <v-btn color="red darken-1" text @click="changeConsumerUnitStatus()"
              >Sim</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showCredentials" persistent max-width="600">
        <v-card>
          <v-card-text class="headline">
            <v-layout>
              <v-flex xs12>
                <v-text-field
                  v-model="lead_credentials.name"
                  label="Usuário"
                  required
                  readonly
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="lead_credentials.password"
                  label="Senha"
                  required
                  readonly
                />
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="mr-2"
                  v-on="on"
                  color="#7d3dff"
                  dark
                  @click="generateLink"
                >
                  <v-icon>link</v-icon>
                </v-btn>
              </template>
              <span>Gerar link para conexão com concessionária</span>
            </v-tooltip>
            <v-btn
              class="mr-2"
              color="red"
              text
              @click="showCredentials = false"
              >Fechar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
import paisesfile from "@/model/paises";
import statesfile from "@/model/state";
import moment from "moment";
import { mapState } from "vuex";
import XLSX from "xlsx";
import CreateExport from "../components/export/CreateExport";
import firestore from "../firebase/firestore";
import { GET_POWERPLANTCOMBO } from "../graphql/powerplants";
import { eventBus } from "../main";
import { updateConsumerUnit } from "../services/consumer_units";
import { getPermission } from "../services/permissions";
import { enviarEmail } from "../services/sendmail";
import { getLeadCredentials, updateUser } from "../services/users";
import { EventBus } from "../utils/event-bus";

export default {
  data: () => ({
    consumerunits: [],
    name: "",
    email: "",
    phone: "",
    status: "",
    cpf: "",
    status_list: [
      { status: "not_payment", label: "NÃO COMISSIONADO" },
      { status: "ATIVO", label: "ATIVO" },
      { status: "INATIVO", label: "INATIVO" },
      { status: "CANCELED", label: "CANCELADO" },
      { status: "SENDED_PROPOSAL", label: "PROPOSTA ENVIADA" },
      { status: "REQUEST_PROPOSAL", label: "PROPOSTA SOLICITADA" },
      { status: "NOT_HOLDER", label: "NÃO É O TITULAR" },
      { status: "AGUARDANDO_CONTA", label: "AGUARDANDO CONTA" },
      { status: "MULTIPLAS_CONTAS", label: "MULTIPLAS INSTALAÇÕES" },
      {
        status: "AGUARDANDO_NRO_INSTALACAO",
        label: "AGUARDANDO NRO INSTALAÇÃO",
      },
      { status: "SEM_RETORNO", label: "SEM RETORNO" },
      { status: "QUALIFICAR_MANUALMENTE", label: "QUALIFICAR MANUALMENTE" },
      { status: "PAYMENT_METHOD_NOT_SELECTED", label: "SEM FORMA DE PAGTO" },
      { status: "IN_QUEUE", label: "NA FILA" },
      { status: "CANCELING", label: "EM CANCELAMENTO" },
      {
        status: "WAIT_ADD_CREDIT_CARD",
        label: "AGUARDANDO INCLUSAO DE CARTAO",
      },
      { status: "VALIDAR_DOCUMENTO", label: "VALIDAR DOCUMENTO" },
      { status: "AGUARDANDO_DOCUMENTO", label: "AGUARDANDO DOCUMENTO" },
      { status: "NAO_INTERESSADO", label: "NÃO INTERESSADO" },
      { status: "DESQUALIFICAR", label: "DESQUALIFICADO" },
      { status: "QUALIFICAR", label: "QUALIFICAR" },
      { status: "VALIDAR_CONTA", label: "VALIDAR CONTA/UC" },
      { status: "SALE_PENDING", label: "AGUARDANDO VENDA" },
    ],

    valid: false,
    data: [
      [
        "indice",
        "nome",
        "email",
        "telefone",
        "data de criacao",
        "ultima atualizacao",
        "assinado em",
        "endereco",
        "cidade",
        "cep",
        "Documento",
        "CPF",
        "ID do usuário",
        "Data de Nascimento",
        "Sexo",
        "Estado Civil",
        "Comunhao de Bens",
        "Status",
        "Profissao",
        "Saldo de Indicação",
        "Recebeu por indicações",
        "metodo de pagamento",
        "possui cartao?",
        "media de consumo",
      ],
    ],
    headers: [
      {
        sortable: true,
        text: "Criado",
        value: "created_at",
      },
      {
        sortable: true,
        text: "Atualizado",
        value: "updated_at",
      },
      {
        sortable: true,
        text: "Name",
        value: "name",
      },
      {
        sortable: true,
        text: "E-mail",
        value: "email",
      },
      {
        sortable: true,
        text: "Telefone",
        value: "phone",
      },
      {
        sortable: true,
        text: "Meio de Inscrição",
        value: "signedcontract_by",
      },
      {
        sortable: true,
        text: "Status",
        value: "status",
      },
      {
        sortable: false,
        text: "Whats",
        value: "whatsapp",
      },
      {
        text: "   ",
        sortable: false,
        name: "edit",
      },
      {
        text: "   ",
        sortable: false,
        name: "customercare",
      },
    ],
    customers: [],
    customer: {},
    totalItemsProcess: 0,
    pagination: {
      rowsPerPage: 25, // -1 for All",
      totalItems: 0,
    },
    pagination_before: {},
    rowsPerPageItems: [5, 10, 25],
    items: [],
    items_complete: [],
    totalItems: 0,
    search: "",
    loading: false,
    loading_search: false,
    loading_export: false,
    dialog: false,
    ucToChange: {},
    showMenu: false,
    x: 0,
    y: 0,
    actions: [
      {
        title: "Proposta enviada",
        icon: "send",
        iconClass: "blue white--text",
        value: 2,
      },
      {
        title: "Contrato Assinado",
        icon: "person",
        iconClass: "amber white--text",
        value: 3,
      },
      {
        title: "Solicitar nova conta",
        icon: "person",
        iconClass: "blue white--text",
        value: 4,
      },
    ],
    states: statesfile.estados,
    paises: paisesfile,
    emailRules: [
      (v) => !!v || "Por favor, informe o email",
      (v) => /.+@.+/.test(v) || "E-mail precisa ser válido",
    ],
    nameRules: [
      (v) => !!v || "Por favor, informe o nome",
      (v) => v.length <= 10 || "Por favor, preencha seu nome completo.",
    ],
    address: {},
    myDate: {},
    ani_ano: 0,
    ani_mes_fix: 0,
    ani_dia: 0,
    dias31: [],
    dias30: [],
    dias29: [],
    dias28: [],
    meses: [],
    anos: [],
    power_plants: [
      {
        id: "Todas usinas",
        name: "Todas usinas",
      },
    ],
    filterPowerPlant: "Todas usinas",
    plantUsers: [],
    lead_credentials: {
      email: "",
      name: "",
      password: "",
      utility_company: "",
    },
    showCredentials: false,
    companies: [
      {
        text: "Elétron",
        value: "eletron",
      },
      {
        text: "Juntos",
        value: "juntos",
      },
    ],
    company: "juntos",
  }),

  components: {
    cpnCreateExport: CreateExport,
  },

  computed: {
    ...mapState(["user"]),
    config() {
      return this.$store.state.config;
    },
    filteredPowerPlants() {
      if (this.user.group === "admin") return this.power_plants;

      let PowerPlantArray = [];
      this.power_plants.filter((power_plant) => {
        return this.user.power_plants.filter((power_plant2) => {
          if (power_plant2.power_plant_id === power_plant.power_plant_id) {
            PowerPlantArray.push(power_plant);
          }
        });
      });
      return PowerPlantArray;
    },
  },

  watch: {
    pagination: {
      handler() {
        const { page, rowsPerPage } = this.pagination;
        /* 
          Se selecionou página anterior
          Pega os dados direto do array items_complete
          */
        if (
          this.pagination_before &&
          this.pagination_before.page > this.pagination.page
        ) {
          this.loading = true;
          this.items = this.items_complete.slice(
            (page - 1) * rowsPerPage,
            page * rowsPerPage,
          );

          this.loading = false;

          /*
          Se selecionou proxima página, mas a pagina selecionada já foi carregada antes
          Pega os dados direto do array items_complete
          */
        } else if (
          this.pagination_before &&
          this.pagination_before.page <= this.pagination.page &&
          this.pagination.page <= this.items_complete.length / rowsPerPage
        ) {
          this.loading = true;
          this.items = this.items_complete.slice(
            (page - 1) * rowsPerPage,
            page * rowsPerPage,
          );

          this.loading = false;

          // Se a pagina é a mesma não faz nada
        } else if (this.pagination_before.page === this.pagination.page) {
          this.loading = true;
          this.items = this.items_complete.slice(
            (page - 1) * rowsPerPage,
            page * rowsPerPage,
          );

          this.loading = false;

          /*
          Se selecionou proxima página, e a pagina selecionada ainda não foi carregada antes
          Busca os dados no firebase e adiciona ao array os dados firebase
          */
        } else {
          this.pagination_before = this.pagination;
          if (this.last) {
            this.loading = true;
            const { page, rowsPerPage } = this.pagination;
            let params = {
              last: this.last,
            };
            if (this.name) {
              params.name = this.name;
            } else if (this.email) {
              params.email = this.email;
            } else if (this.phone) {
              params.phone = this.phone;
            } else if (this.cpf) {
              params.cpf = this.cpf;
            } else if (this.status) {
              params.status = this.status;
            }
            this.getUsers(params).onSnapshot(
              { includeMetadataChanges: true },
              (res) => {
                this.last = res.docs[res.docs.length - 1];
                const changes = res.docChanges();
                changes.forEach((change) => {
                  if (change.type === "added") {
                    this.items.push({
                      ...change.doc.data(),
                      id: change.doc.id,
                    });

                    this.items_complete.push({
                      ...change.doc.data(),
                      id: change.doc.id,
                    });
                    this.loading = false;
                  } else {
                    this.loading = false;
                  }
                });

                if (this.company === "eletron") {
                  this.items = this.items?.filter(
                    (item) => item?.company === "eletron",
                  );
                } else {
                  this.items = this.items?.filter(
                    (item) => item?.company !== "eletron",
                  );
                }

                this.pagination.totalItems = this.items?.length;
              },
            );
            if (rowsPerPage > 0) {
              this.items = this.items.slice(
                (page - 1) * rowsPerPage,
                page * rowsPerPage,
              );
            }
          } else {
            this.loading = false;
          }
        }
      },
      deep: true,
    },
  },
  beforeCreate() {
    this.$store.dispatch("setInitialsConfig");
  },
  created() {
    this.loading = true;
    const params = {};
    this.getUsers(params).onSnapshot(
      { includeMetadataChanges: true },
      (res) => {
        const changes = res.docChanges();
        this.last = res.docs[res.docs.length - 1];
        changes.forEach((change) => {
          if (change.type === "added") {
            this.items.push({
              ...change.doc.data(),
              id: change.doc.id,
            });

            this.items_complete.push({
              ...change.doc.data(),
              id: change.doc.id,
            });
            this.loading = false;
          } else {
            this.loading = false;
          }
        });

        if (this.company === "eletron") {
          this.items = this.items?.filter(
            (item) => item?.company === "eletron",
          );
        } else {
          this.items = this.items?.filter(
            (item) => item?.company !== "eletron",
          );
        }

        this.pagination.totalItems = this.items?.length;
      },
    );
  },
  methods: {
    openMyDialog() {
      eventBus.$emit("dialog_export", true); // emit the event to the bus
    },
    goInvoices(customer_id) {
      this.$router.push({
        path: "/unidades-consumidoras/faturas/" + customer_id,
        params: { customer_id: customer_id },
      });
    },
    goToCustomerCare(customer) {
      // const routeData = this.$router.resolve({ path: "/atendimento/?email=" + customer.email })
      // window.open(routeData.href, "_blank")
      this.$router.push({ path: "/atendimento/?email=" + customer.email });
    },
    customerSelected(customer) {
      this.loading = true;
      EventBus.$emit("userSelected", customer);
      const routeData = this.$router.resolve({
        path: "/membro/" + customer.customer_id,
        params: { id: customer.customer_id },
      });
      window.open(routeData.href, "_blank");
    },
    formatWhatsappPhone(phone) {
      if (!phone) return "";
      let newphone = phone.replace(/\D/g, "");
      if (newphone.substring(0, 2) !== "55") {
        newphone = "55" + newphone;
      }
      return newphone;
    },
    async enviarEmail(customer, template) {
      const data = {
        email: customer.email,
        name: customer.name,
        dynamic_template_data: {
          name: customer.name,
          email: customer.email,
        },
        template_id: template,
      };

      enviarEmail(data)
        .then(() => {
          if (customer.emailconta && typeof customer.emailconta === "number") {
            customer.emailconta++;
          } else {
            customer.emailconta = 1;
          }

          updateUser(customer.email, customer)
            .then(alert("E-mail enviado com sucesso!"))
            .catch((error) => {
              console.error(
                "Erro ao atualizar envio de email do customer. ",
                error,
              );
              alert("Erro ao atualizar envio de email do customer. ", error);
            });
        })
        .catch((error) => {
          console.dir("Erro ao enviar email. ", error);
          alert("Ops! Falha ao enviar email.", error);
        });
    },
    async proposta(select_customer, value) {
      select_customer.step = value;
      await updateUser(select_customer.email, select_customer)
        .then(() => {
          this.$nextTick(() => {
            alert("Dado atualizado com sucesso!");
          });
        })
        .catch((error) => {
          console.error("Erro ao atualizar os dados. ", error);
          alert("Erro ao atualizar os dados. ", error);
        });
    },
    newBill(select_customer) {
      //Solicita ao usuário nova conta, pois a atual não está legivel
      select_customer.step = 1;
      this.enviarEmail(
        select_customer,
        process.env.VUE_APP_SENDGRID_TEMPLATE_NOVACONTA,
      );
    },
    formatarData: function (value) {
      if (!value) return "-";
      if (typeof value == "string") {
        return moment(value.toDate()).format("DD/MM/YYYY");
      }
      let timestamp = value; // firebase data
      let myDate = new Date(); // date object
      if (timestamp.valueOf().seconds) {
        myDate = new Date(timestamp.seconds * 1000); // date object
      } else if (timestamp.valueOf()._seconds) {
        myDate = new Date(timestamp._seconds * 1000); // date object
      } else {
        return "-";
      }
      return moment(myDate.toISOString()).format("DD/MM/YYYY");
    },
    getUsers(params) {
      let ref = firestore.collection("users");

      if (params.name) {
        ref = ref.where("name_insensitive", ">=", params.name.toLowerCase());
      } else if (params.email) {
        ref = ref.where("email", ">=", params.email);
      } else if (params.phone) {
        ref = ref.where("phone", ">=", params.phone);
      } else if (params.cpf) {
        ref = ref.where("cpf", "==", params.cpf);
      } else if (params.status) {
        ref = ref.where("status", "==", params.status);
      } else if (this.company === "eletron") {
        ref = ref.where("company", "==", "eletron");
      }
      ref = ref.limit(this.pagination.rowsPerPage || 25);

      if (params.name) {
        ref = ref.orderBy(
          "name_insensitive",
          this.pagination.descending ? "desc" : "asc",
        );
      } else if (params.email) {
        ref = ref.orderBy("email", "asc");
      } else if (params.phone) {
        ref = ref.orderBy("phone", "asc");
      } else if (params.status) {
        ref = ref.orderBy("updated_at", "desc");
      }

      if (params.last) {
        ref = ref.startAfter(this.last);
      }
      return ref;
    },
    async _search() {
      this.loading_search = true;
      this.items = [];
      this.items_complete = [];
      this.last = null;
      this.pagination_before = {};

      let params = {};
      if (this.name) {
        params.name = this.name;
      } else if (this.email) {
        params.email = this.email;
      } else if (this.phone) {
        params.phone = this.phone;
      } else if (this.cpf) {
        params.cpf = this.cpf;
      } else if (this.status) {
        params.status = this.status;
      }
      this.getUsers(params)
        .get()
        .then(async (users) => {
          this.last = users.docs[users.docs.length - 1];
          if (users.size > 0) {
            await users.docs.map(async (snapshot, index) => {
              const data = {
                index,
                id: snapshot.id,
                ...snapshot.data(),
              };
              this.items.push(data);

              this.items_complete.push(data);
              if (users.size - 1 === index) {
                this.loading_search = false;
              }
            });

            if (this.company === "eletron") {
              this.items = this.items?.filter(
                (item) => item?.company === "eletron",
              );
            } else {
              this.items = this.items?.filter(
                (item) => item?.company !== "eletron",
              );
            }
            this.pagination.totalItems = this.items?.length;
          } else {
            this.loading_search = false;
          }
        })
        .catch((error) => {
          console.error(error);
          this.loading_search = false;
        });
      this.pagination = {
        ...this.pagination,
        descending: false,
        page: 1,
        rowsPerPage: 25,
        sortBy: null,
      };
      const { page, rowsPerPage } = this.pagination;

      if (rowsPerPage > 0) {
        this.items = this.items.slice(
          (page - 1) * rowsPerPage,
          page * rowsPerPage,
        );
        this.items = this.items.filter((item) => item.is_test === false);
      }
    },
    async newCustomer() {
      this.$router.push({ path: "/membro/" });
    },
    async _clear() {
      this.loading_search = true;
      this.items = [];
      this.items_complete = [];
      this.last = null;
      this.pagination_before = {};
      this.name = "";
      this.email = "";
      this.phone = "";
      this.status = "";
      this.cpf = "";
      this.pagination = [];
      this._search();
    },
    async _export() {
      this.loading_export = true;
      const users = await firestore
        .collection("users")
        .orderBy("created_at", "asc")
        .get();
      await users.docs.map(async (item, index) => {
        this.data.push([
          index + 1,
          item.id || "",
          item.data().name,
          item.data().email,
          item.data().phone || "",
          item.data().indicator_code || "",
          item.data().last_invoice || "",
          item.data().payment_type === "boleto"
            ? "boleto"
            : item.data().payment_type === "pix"
              ? "pix"
              : "cartão de crédito" || "",
          item.data().card_default ? "Sim" : "Não",
          this.formatarData(item.data().updated_at),
          this.formatarData(item.data().created_at),
          this.formatarData(
            item.data().signedcontract_at
              ? item.data().signedcontract_at
              : item.data().created_at,
          ),
          item.status || "",
        ]);

        if (users.size - 1 === index) {
          const ws = XLSX.utils.aoa_to_sheet(this.data);
          const wb = XLSX.utils.book_new();

          const file = "clientes_" + this.formatFileName(new Date());
          XLSX.utils.book_append_sheet(wb, ws, file);
          XLSX.writeFile(wb, file + ".xlsx");
          this.loading_export = false;
        }
      });
    },
    formatFileName(value) {
      if (!value) return "";
      const year = value.getYear();
      const month = value.getMonth() + 1;
      const day = value.getDay();
      const hour = value.getHours();
      const minute = value.getMinutes();
      return day + "" + month + "" + year + "" + hour + "" + minute;
    },
    openModalAndSaveUC(ucToChange) {
      this.dialog = true;
      this.ucToChange = ucToChange;
    },
    changeConsumerUnitStatus() {
      if (typeof this.ucToChange.status === "undefined") {
        this.ucToChange.status = "activated";
      }
      this.ucToChange.status =
        this.ucToChange.status == "canceled" ? "activated" : "canceled";
      const status = this.ucToChange.status;
      updateConsumerUnit(this.ucToChange.installation_number, { status });
      this.dialog = false;
    },
    canceledOrActivatedText() {
      return typeof this.ucToChange.status === "undefined" ||
        this.ucToChange.status == "activated"
        ? "DESATIVAR"
        : "ATIVAR";
    },

    async generateLink(user) {
      try {
        this.loadingChange = true;

        const permission = await getPermission("decrypt_login", this.user.id);

        if (!permission.data.has_permission) {
          alert("Usuário sem permissão para realizar essa ação");
          return false;
        }
      } catch (err) {
        this.loadingChange = false;
        alert("Falha ao consultar permissão do usuário");
        console.error("Falha ao consultar permissão", err);
        return false;
      }
      const email = this.lead_credentials?.email || user?.email;
      const utility_company =
        this.lead_credentials?.utility_company || user?.utility_company;
      const link = `https://juntos.eco/portal?lead=${email}&utility=${utility_company}`;
      navigator.clipboard.writeText(link);
      alert("Link gerado e copiado para área de transferência.");
      const generated_link = user?.generated_link ?? 0;
      const updatedUser = {
        generated_link: generated_link + 1,
      };
      updateUser(user.id, updatedUser);
    },

    async decryptData(user) {
      try {
        this.loadingChange = true;

        const permission = await getPermission("decrypt_login", this.user.id);

        if (!permission.data.has_permission) {
          alert("Usuário sem permissão para realizar essa ação");
          this.indicationDialog = false;
          return false;
        }
      } catch (err) {
        this.loadingChange = false;
        alert("Falha ao consultar permissão do usuário");
        console.error("Falha ao consultar permissão", err);
        this.indicationDialog = false;
        return false;
      }
      getLeadCredentials(user.email).then((res) => {
        if (res.status === 200) {
          this.lead_credentials = res.data.lead_credentials;
          this.lead_credentials.email = user.email;
          this.lead_credentials.utility_company = user.utility_company;
          this.showCredentials = true;
        }
      });
    },
  },
  filters: {
    formatarData: function (value) {
      if (!value) return "";
      if (value._seconds) {
        let timestamp = value; // firebase data
        let myDate = new Date(timestamp._seconds * 1000); // date object
        return moment(myDate).format("DD/MM/YYYY");
      } else if (value.seconds) {
        let timestamp = value; // firebase data
        let myDate = new Date(timestamp.seconds * 1000); // date object
        return moment(myDate).format("DD/MM/YYYY");
      } else {
        return moment(value).format("DD/MM/YYYY");
      }
    },
    formatStep: function (value) {
      var step_text = "";
      if (!value) return "";

      if (value === "0") {
        step_text = "Sem contas";
      } else if (value === "1") {
        step_text = "Gerando propostas";
      } else {
        step_text = "error";
      }
      return step_text;
    },
    filtrarPorUsina: function (customers, filtro, usinas) {
      //Checar se o filtro é necessário
      if (filtro != "Todas usinas") {
        //Obter o objeto usina referente ao filtro
        let usinaFiltroArr = usinas.filter(function (usina) {
          return filtro.includes(usina.id);
        });
        let usinaFiltro = usinaFiltroArr[0];
        return customers.filter(function (customer) {
          //Verificar se o membro está presente no objeto usina
          //Em caso positivo, o array 'aux' resultante terá comprimento diferente de 0
          let aux = usinaFiltro.users.filter(function (usinaUser) {
            return usinaUser.includes(this.userId);
          }, customer);
          if (aux.length != 0) return true;
          else return false;
        });
      } else {
        return customers;
      }
    },
  },
  apollo: {
    powerplants: {
      query: GET_POWERPLANTCOMBO,
      result({ data, loading }) {
        this.power_plants = data.powerplants;
        this.loading = loading;
      },
      error(error) {
        console.error("We've got an error!", error);
      },
    },
  },
};
</script>
<style scoped>
.zoom {
  transition: transform 0.2s;
  margin: 0 auto;
}

.zoom:hover {
  -ms-transform: scale(1.4); /* IE 9 */
  -webkit-transform: scale(1.4); /* Safari 3-8 */
  transform: scale(1.4);
}
</style>
